export { FEATURE_FLAGS_PROD } from './feature-flags-prod'
export { FEATURE_FLAGS_DEV } from './feature-flags-dev'
export {
  FEATURE_FLAG_RECORD_MAP,
  type FeatureFlags,
  type IFeatureFlags,
} from './feature-flags.types'
